import { render } from "./SceneIntroduction.vue?vue&type=template&id=19242e66"
import script from "./SceneIntroduction.vue?vue&type=script&lang=js"
export * from "./SceneIntroduction.vue?vue&type=script&lang=js"

import "./SceneIntroduction.vue?vue&type=style&index=0&id=19242e66&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__